/**
 * FAQ action types
 */
export const FaqType = {
  FETCH_FAQS_REQUEST: 'FETCH_FAQS_REQUEST',
  FETCH_FAQS_SUCCESS: 'FETCH_FAQS_SUCCESS',
  FETCH_FAQS_FAILURE: 'FETCH_FAQS_FAILURE',

  INSERT_FAQ_REQUEST: 'INSERT_FAQ_REQUEST',
  INSERT_FAQ_SUCCESS: 'INSERT_FAQ_SUCCESS',
  INSERT_FAQ_FAILURE: 'INSERT_FAQ_FAILURE',

  UPDATE_FAQ_REQUEST: 'UPDATE_FAQ_REQUEST',
  UPDATE_FAQ_SUCCESS: 'UPDATE_FAQ_SUCCESS',
  UPDATE_FAQ_FAILURE: 'UPDATE_FAQ_FAILURE',
}